module.exports = __webpack_public_path__ + "static/Lazienka2_V03-39a50e80ab7d4e37c6a265e29d0b1bf1.jpg";